import { supabase } from '../supabase/client';
import { TimelineEvent, TimelineEventType } from './types';

export const fetchTimeline = async (rechnungId: string): Promise<TimelineEvent[]> => {
  const { data, error } = await supabase
    .from('rechnungen_timeline')
    .select('*, user:user_id(full_name), ziel_user:ziel_user_id(full_name)')
    .eq('rechnung_id', rechnungId)
    .order('created_at', { ascending: true });

  if (error) throw error;
  return (data || []) as TimelineEvent[];
};

export const addTimelineEvent = async (
  rechnungId: string,
  typ: TimelineEventType,
  userId: string,
  inhalt?: string,
  zielUserId?: string
): Promise<void> => {
  const { error } = await supabase.from('rechnungen_timeline').insert({
    rechnung_id: rechnungId,
    typ,
    inhalt: inhalt || null,
    user_id: userId,
    ziel_user_id: zielUserId || null,
  });
  if (error) throw error;
};

export const addKommentar = async (
  rechnungId: string,
  userId: string,
  text: string
): Promise<void> => {
  await addTimelineEvent(rechnungId, 'kommentar', userId, text);
};
